export default ({ color, fontSize, typography }) => ({
  chartPanelContainer: {
    color: color.bodyText,
    borderRadius: 5,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 24,
    '@media print': {
      pageBreakAfter: 'always',
    },
  },
  printfiltersummary: {
    display: 'none',
    '@media print': {
      fontSize: fontSize.smallText,
      fontFamily: typography.bodyText,
      fontStyle: 'normal',
      fontWeight: 'normal',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'start',
      margin: '10px 10px 24px 0px',
    },
  },
  printMetricName: {
    display: 'none',
    '@media print': {
      display: 'block',
      marginTop: 10,
      fontSize: fontSize.smallText,
      fontFamily: typography.bodyText,
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
  },
  printDateFilterSummary: {
    display: 'none',
    '@media print': {
      display: 'block',
      fontSize: fontSize.smallText,
      fontFamily: typography.bodyText,
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
  },
  printdatafilterelem: {
    '@media print': {
      marginBottom: 4,
    },
  },
  printDateSummary: {
    marginTop: 10,
  },
  printfilterContainer: {
    display: 'none',
    '@media print': {
      display: 'flex',
    },
  },
  panelHeader: {
    height: 'auto',
    borderBottom: `1px solid ${color.borderColor}`,
    padding: '26px 0px 0px 20px',
  },
  panelTitleDesc: {
    marginBottom: 7,
  },
  label: {
    color: `${color.link}`,
    fontFamily: typography.bodyText,
    fontSize: fontSize.small,
    width: 'auto',
    '@media print': {
      width: '80%',
      color: '#000',
    },
  },
  smallLabel: {
    color: color.smallText,
    fontFamily: typography.smallText,
    fontSize: fontSize.smallText,
    marginBottom: 5,
    '@media print': {
      marginBottom: 0,
    },
  },
  metricLabel: {
    color: color.smallText,
    fontFamily: typography.smallText,
    fontSize: fontSize.smallText,
    marginBottom: 19,
    '@media print': {
      marginBottom: 0,
    },
  },
  dataSourceLabel: {
    fontSize: fontSize.smallText,
    marginBottom: 2,
  },
  metricFilter: {
    display: 'inline-block',
    '@media print': {
      margin: '0 auto',
    },
  },
  dataSourceFilter: {
    marginLeft: 16,
    display: 'inline-block',
  },
  printdataSourceFilter: {
    maxWidth: 400,
  },
  filterContainer: {
    display: 'flex',
    height: 72,
  },
  dateFilter: {
    display: 'inline-block',
    marginLeft: 'auto',
    marginRight: 16,
  },
  dataSourceBtn: {
    color: `${color.accent}`,
    border: `1px solid ${color.borderColorLight}`,
    height: 36,
    boxSizing: 'border-box',
    backgroundColor: `${color.white}`,
    borderRadius: 3,
    fontWeight: 'normal',
    justifyContent: 'center',
    alignItems: 'center',
    '&:focus': {
      boxShadow: `0 0 0 1px ${color.white}, 0 0 0 2px ${color.primaryButtonBackground}`,
    },
  },
  chartContainer: {
    display: 'flex',
    maxHeight: '26vw',
    '@media print': {
      display: 'block',
      maxHeight: 'none',
    },
  },
  chartBody: {
    width: '70%',
    borderRight: `1px solid ${color.borderColor}`,
    display: 'inline-block',
    paddingLeft: 20,
    boxSizing: 'border-box',
    paddingBottom: 20,
    height: '26vw',
    '& svg': {
      overflow: 'visible',
      height: 'auto',
    },
    '& .VictoryContainer': {
      bottom: 22,
      display: 'flex',
      '& div:last-child': {
        height: '100%',
        display: 'flex',
      },
    },
    '@media print': {
      height: '40vw',
      width: '100%',
      borderRight: `0px solid ${color.borderColor}`,

    },
  },
  loader: {
    width: '100%',
    display: 'flex',
    height: 500,
    justifyContent: 'center',
    alignItems: 'center',
  },
  chartFooter: {
    height: 24,
    width: '100%',
    borderTop: `1px solid ${color.borderColorLight}`,
    color: `${color.footerLink}`,
    paddingLeft: 20,
    fontSize: fontSize.smallText,
    paddingTop: 10,
  },
  legend: {
    width: '30%',
    display: 'inline-block',
  },
  blockLegendItem: {
    display: 'inline-block',
    width: 25,
    height: 18,
    marginRight: 10,
    WebkitPrintColorAdjust: 'exact',
    colorAdjust: 'exact',
  },
  lineLegendItem: {
    display: 'inline-block',
    width: 30,
    height: 6,
    marginRight: 10,
    WebkitPrintColorAdjust: 'exact',
    colorAdjust: 'exact',
  },
  lineLegendItem__dashed: {
    height: 'auto',
    display: 'inline-block',
    width: 25,
    marginRight: 10,
    WebkitPrintColorAdjust: 'exact',
    colorAdjust: 'exact',
  },
});